import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { GroupTitle } from '.'

const Container = styled.div`
  ${({ isContentHidden, hiddenMaxHeight = '100%' }) => css`
    border: ${({ theme, noBorder }) => !noBorder && `${theme.colors.groupBorder} .1rem solid`};
    border-radius: 6px;
    padding: 1.5rem 2rem;
    position: relative;
    text-align: left;
    flex-grow: ${({ grow }) => grow};
    ${isContentHidden &&
    css`
      height: ${hiddenMaxHeight};
    `}
  `}
`

const Content = styled.div`
  ${({ isContentHidden }) => css`
    position: relative;
    width: 100%;
    height: 100%;
    visibility: ${isContentHidden ? 'hidden' : 'visible'};
  `}
`

const FieldsGroup = ({ title, children, isContentHidden, titleNowrap, ...props }) => (
  <Container isContentHidden={isContentHidden} {...props}>
    <Content isContentHidden={isContentHidden}>
      {title && <GroupTitle nowrap={titleNowrap}>{title}</GroupTitle>}
      {children}
    </Content>
  </Container>
)

FieldsGroup.defaultProps = {
  children: null,
  title: '',
  direction: 'row',
  isContentHidden: false,
  noBorder: false,
}

FieldsGroup.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
  direction: PropTypes.string,
  isContentHidden: PropTypes.bool,
  noBorder: PropTypes.bool,
}

export default FieldsGroup
